import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  selectedProducts: [],
  lastUpdated: null
};

const productReducer = createReducer(initialState, {

'SET_SELECTED_PRODUCTS': (state, action) => {
   console.log('SET_SELECTED_PRODUCTS called:', action);
  if (!Array.isArray(action.payload)) {
    console.error('Payload must be an array', action.payload);
    return;
  }
  if (action.meta && action.meta.source === 'register') {
    state.selectedProducts = action.payload;
    state.lastUpdated = new Date().toISOString();
    console.log('Products updated in Redux from Register:', {
      products: state.selectedProducts,
      count: state.selectedProducts.length
    });
  } else {
    console.log('Ignored SET_SELECTED_PRODUCTS from non-register source');
  }
},
'SET_PRODUCT_MASTER_LIST': (state, action) => {
  state.productMasterList = action.payload;
},
  'CLEAR_SELECTED_PRODUCTS': (state) => {
    state.selectedProducts = [];
    state.lastUpdated = new Date().toISOString();
  }
});

export default productReducer;